module.exports = __webpack_public_path__ + "img/再见.7abfce51.png";